(function () {
  'use strict';

  function fetchConfig(type) {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/' + (type || 'json'),
      },
    };
  }

  function getMiniCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getCartAddUrl() {
    if (window.routes && window.routes.cart_add_url) {
      return window.routes.cart_add_url;
    }
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js';
  }

  function getSectionUrl() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + '?sections=form-mini-cart';
  }

  function reinitShippingBars(subtotal) {
    if (subtotal == null) return;
    document.querySelectorAll('free-ship-progress-bar').forEach(function (el) {
      el.dataset.order = subtotal;
      if (typeof el.init === 'function') {
        el.init(subtotal);
      }
    });
  }

  function updateCartCount(cart) {
    if (!cart || cart.item_count == null) return;

    document.querySelectorAll('.cart-count').forEach(function (el) {
      if (el.classList.contains('cart-count-drawer')) {
        el.textContent = '(' + cart.item_count + ')';
      } else {
        el.textContent = cart.item_count;
      }
    });

    if (document.querySelector('header-total-price')) {
      document.querySelector('header-total-price').updateTotal(cart);
    }

    reinitShippingBars(cart.items_subtotal_price);
  }

  function applyMiniCartSectionHtml(sectionHtml) {
    var miniCart = getMiniCart();
    if (!miniCart || !sectionHtml) return false;

    var el = document.getElementById('form-mini-cart');
    if (!el) return false;

    var html = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var inner = html.querySelector('#form-mini-cart');
    if (!inner) return false;

    el.innerHTML = inner.innerHTML;

    if (window.refreshPremiumCartBarFromSection) {
      window.refreshPremiumCartBarFromSection(sectionHtml);
    }

    var countdown = miniCart.querySelector('.cart-countdown-time');
    var htmlCountdown = html.querySelector('.cart-countdown-time');
    if (countdown && htmlCountdown) {
      countdown.innerHTML = htmlCountdown.innerHTML;
      if (typeof miniCart.countdownTimer === 'function') {
        miniCart.countdownTimer();
      }
    }

    return true;
  }

  function finishMiniCartRefresh() {
    var miniCart = getMiniCart();
    if (!miniCart) return;

    if (miniCart.classList && miniCart.classList.contains('is-empty')) {
      miniCart.classList.remove('is-empty');
    }
    if (typeof miniCart.open === 'function') miniCart.open();
    if (typeof miniCart.cartAction === 'function') miniCart.cartAction();
    if (typeof Shopify !== 'undefined' && typeof Shopify.termsConditionsAction === 'function') {
      Shopify.termsConditionsAction();
    }

    initAll();
    reloadMinicartFbtBlocks();

    if (typeof BlsLazyloadImg !== 'undefined') BlsLazyloadImg.init();
    if (typeof BlsSettingsSwiper !== 'undefined') BlsSettingsSwiper.init();
  }

  function fetchMiniCartSection() {
    return fetch(getSectionUrl())
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data && data['form-mini-cart']) {
          return data['form-mini-cart'];
        }
        return null;
      });
  }

  function refreshMiniCartAfterCartChange() {
    var notification = document.getElementById('bls-header_minicart');
    if (notification) {
      notification.classList.add('start', 'loading');
    }

    return fetchMiniCartSection()
      .then(function (html) {
        if (html) applyMiniCartSectionHtml(html);
        finishMiniCartRefresh();
        if (notification) {
          notification.classList.add('finish');
          setTimeout(function () {
            var headerMinicart = document.querySelector('.header_minicart');
            if (headerMinicart) {
              headerMinicart.classList.remove('start', 'loading', 'finish');
            }
          }, 500);
        }
      })
      .catch(function (err) {
        console.error('[CartFBT] Section refresh failed', err);
        finishMiniCartRefresh();
      });
  }

  function refreshMiniCart(parsedState) {
    var sectionHtml = parsedState && parsedState.sections ? parsedState.sections['form-mini-cart'] : null;
    if (sectionHtml && applyMiniCartSectionHtml(sectionHtml)) {
      finishMiniCartRefresh();
      return Promise.resolve(true);
    }
    return refreshMiniCartAfterCartChange();
  }

  function refreshCartOnly(triggerBtn) {
    if (triggerBtn) {
      triggerBtn.classList.add('cart-fbt--loading');
      triggerBtn.disabled = true;
    }

    return fetch('/cart.json')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart);
        return refreshMiniCartAfterCartChange();
      })
      .finally(function () {
        if (triggerBtn) {
          triggerBtn.classList.remove('cart-fbt--loading');
          triggerBtn.disabled = false;
        }
      });
  }

  function showCartError(message) {
    if (!message) return;
    if (typeof EasyDialogBox !== 'undefined') {
      var errorDialog = EasyDialogBox.create(
        'cart_fbt_error',
        'dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading',
        '',
        '<p class="form-message form-message--error">' + message + '</p>'
      );
      errorDialog.onClose = errorDialog.destroy;
      errorDialog.show();
      return;
    }
    console.error('[CartFBT]', message);
  }

  function getCartVariantIds() {
    return fetch('/cart.json')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).map(function (item) { return String(item.variant_id); });
      })
      .catch(function () { return []; });
  }

  function isItemInCart(item, cartVariantIds) {
    if (item.dataset.inCart === 'true') return true;
    var variantId = String(item.dataset.variantId || '');
    return variantId && cartVariantIds.indexOf(variantId) !== -1;
  }

  function collectAddableItems(root, cartVariantIds) {
    var items = [];
    var seen = [];
    root.querySelectorAll('.cart-fbt__item').forEach(function (item) {
      if (item.dataset.available === 'false') return;
      if (isItemInCart(item, cartVariantIds || [])) return;
      var id = parseInt(item.dataset.variantId, 10);
      if (!id || seen.indexOf(String(id)) !== -1) return;
      seen.push(String(id));
      items.push({ id: id, quantity: 1 });
    });
    return items;
  }

  function syncInCartFromCart(root, cartVariantIds) {
    root.querySelectorAll('.cart-fbt__item').forEach(function (item) {
      var inCart = isItemInCart(item, cartVariantIds);
      item.dataset.inCart = inCart ? 'true' : 'false';
      item.classList.toggle('cart-fbt__item--in-cart', inCart);
    });

    syncAddAllState(root, cartVariantIds);
  }

  function addSingleItem(item) {
    return fetch(getCartAddUrl(), Object.assign({}, fetchConfig('json'), {
      body: JSON.stringify({ items: [item] }),
    }))
      .then(function (response) {
        return response.text().then(function (text) {
          var parsed = {};
          try {
            parsed = JSON.parse(text);
          } catch (error) {
            parsed = { message: text };
          }
          if (!response.ok || (parsed.status && Number(parsed.status) >= 400) || parsed.errors) {
            var message = parsed.description || parsed.message || parsed.errors || 'Unable to add item.';
            return { ok: false, item: item, message: message };
          }
          return { ok: true, item: item };
        });
      })
      .catch(function (error) {
        return { ok: false, item: item, message: error && error.message ? error.message : 'Unable to add item.' };
      });
  }

  function addItems(items, triggerBtn) {
    if (!items.length) return refreshCartOnly(triggerBtn);

    var notification = document.getElementById('bls-header_minicart');
    var results = [];

    if (triggerBtn) {
      triggerBtn.classList.add('cart-fbt--loading');
      triggerBtn.disabled = true;
    }
    if (notification) {
      notification.classList.add('start', 'loading');
    }

    return items.reduce(function (chain, item) {
      return chain.then(function () {
        return addSingleItem(item).then(function (result) {
          results.push(result);
        });
      });
    }, Promise.resolve())
      .then(function () {
        var addedCount = results.filter(function (result) { return result.ok; }).length;
        if (!addedCount) {
          showCartError('These recommended products are not available in the required quantity right now.');
          throw new Error('No FBT items added');
        }
        return fetch('/cart.json');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart);
        return refreshMiniCartAfterCartChange();
      })
      .catch(function (err) {
        console.error('[CartFBT]', err);
        throw err;
      })
      .finally(function () {
        if (triggerBtn) {
          triggerBtn.classList.remove('cart-fbt--loading');
          triggerBtn.disabled = false;
        }
      });
  }

  function syncFbtCollapseState(root, cartVariantIds) {
    var toggle = root.querySelector('[data-fbt-toggle]');
    var summary = root.querySelector('[data-fbt-summary]');
    if (!toggle) return;

    var addable = collectAddableItems(root, cartVariantIds).length;
    var itemCount = root.querySelectorAll('.cart-fbt__item').length;
    root.classList.toggle('cart-fbt--all-in-cart', addable === 0);

    if (summary) {
      summary.textContent = addable === 0
        ? itemCount + ' items · All added'
        : itemCount + ' items · ' + addable + ' to add';
    }

    setFbtCollapsed(root);
  }

  function setFbtCollapsed(root) {
    if (!root) return;
    var toggle = root.querySelector('[data-fbt-toggle]');
    var body = root.querySelector('[data-fbt-body]');
    root.classList.add('cart-fbt--collapsed');
    root.dataset.fbtUserCollapsed = 'true';
    delete root.dataset.fbtUserExpanded;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (body) body.setAttribute('inert', '');
  }

  function setFbtExpanded(root) {
    if (!root) return;
    var body = root.querySelector('[data-fbt-body]');
    root.classList.remove('cart-fbt--collapsed');
    root.dataset.fbtUserExpanded = 'true';
    delete root.dataset.fbtUserCollapsed;
    if (body) body.removeAttribute('inert');
  }

  window.cartFbtForceCollapse = function () {
    document.querySelectorAll('[data-fbt-root]').forEach(setFbtCollapsed);
  };

  function toggleFbtCollapse(root) {
    var toggle = root.querySelector('[data-fbt-toggle]');
    if (!toggle) return;

    var collapsed = root.classList.toggle('cart-fbt--collapsed');
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');

    if (collapsed) {
      setFbtCollapsed(root);
    } else {
      setFbtExpanded(root);
    }
  }

  function initCartFbt(root) {
    if (!root || root.dataset.fbtBound === 'true') return;
    root.dataset.fbtBound = 'true';

    setFbtCollapsed(root);

    var addAllBtn = root.querySelector('[data-fbt-add-all]');
    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        var textEl = addAllBtn.querySelector('.cart-fbt__add-all-text');
        var originalText = textEl ? textEl.textContent.trim() : '';

        addAllBtn.classList.add('cart-fbt--loading');
        addAllBtn.disabled = true;

        getCartVariantIds()
          .then(function (cartVariantIds) {
            var items = collectAddableItems(root, cartVariantIds);
            return addItems(items, addAllBtn).then(function () {
              if (items.length) {
                addAllBtn.classList.add('cart-fbt__add-all--success');
                if (textEl) textEl.textContent = 'ADDED ✓';
                setTimeout(function () {
                  addAllBtn.classList.remove('cart-fbt__add-all--success');
                  getCartVariantIds().then(function (ids) {
                    syncInCartFromCart(root, ids);
                  });
                }, 1800);
              } else if (textEl && originalText) {
                textEl.textContent = 'UPDATED ✓';
                setTimeout(function () {
                  if (textEl) textEl.textContent = originalText;
                }, 1800);
              }
            });
          })
          .catch(function () {
            addAllBtn.classList.remove('cart-fbt--loading');
          })
          .finally(function () {
            addAllBtn.classList.remove('cart-fbt--loading');
            addAllBtn.disabled = false;
          });
      });
    }

    getCartVariantIds().then(function (ids) {
      syncInCartFromCart(root, ids);
      syncFbtCollapseState(root, ids);
    });
  }

  function syncAddAllState(root, cartVariantIds) {
    var addAllBtn = root.querySelector('[data-fbt-add-all]');
    if (!addAllBtn) return;

    var addable = collectAddableItems(root, cartVariantIds).length;
    var textEl = addAllBtn.querySelector('.cart-fbt__add-all-text');
    var defaultText = addAllBtn.getAttribute('data-default-text');

    if (!defaultText && textEl) {
      defaultText = textEl.textContent.trim();
      addAllBtn.setAttribute('data-default-text', defaultText);
    }

    addAllBtn.disabled = false;
    addAllBtn.classList.remove('cart-fbt__add-all--disabled');
    root.classList.toggle('cart-fbt--all-in-cart', addable === 0);

    if (textEl && addable === 0) {
      textEl.textContent = 'ALL ADDED';
    } else if (textEl && defaultText) {
      textEl.textContent = defaultText;
    }

    syncFbtCollapseState(root, cartVariantIds);
  }


  function ensureMinicartFbtVisible() {
    var form = document.getElementById('form-mini-cart');
    if (!form || form.querySelector('[data-fbt-root]') || form.dataset.fbtEnsuring === 'true') return;

    form.dataset.fbtEnsuring = 'true';
    fetch(getSectionUrl())
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var sectionHtml = data && data['form-mini-cart'];
        if (!sectionHtml) return;

        var html = document.createElement('div');
        html.innerHTML = sectionHtml;
        var freshSlot = html.querySelector('.bls-minicart-fbt-slot');
        if (!freshSlot || !freshSlot.querySelector('[data-fbt-root], minicart-fbt')) return;

        var currentForm = document.getElementById('form-mini-cart');
        if (!currentForm || currentForm.querySelector('[data-fbt-root]')) return;

        var currentItems = currentForm.querySelector('.bls-items');
        if (!currentItems) return;

        var besideMobile = currentItems.querySelector('minicart-recommendations-beside, .cart-recomment-beside-mobile');
        currentItems.insertBefore(freshSlot, besideMobile || null);

        var root = freshSlot.querySelector('[data-fbt-root]');
        if (root) initCartFbt(root);
        initMinicartFbtElements();
    initCartFbtVisibilityGuard();
      initCartFbtVisibilityGuard();
      })
      .catch(function (err) {
        console.error('[CartFBT] Ensure visible failed', err);
      })
      .finally(function () {
        var currentForm = document.getElementById('form-mini-cart');
        if (currentForm) delete currentForm.dataset.fbtEnsuring;
      });
  }

  function initAll() {
    document.querySelectorAll('[data-fbt-root]:not([data-fbt-bound="true"])').forEach(initCartFbt);
  }

  function fbtHasItems(root) {
    return root && root.querySelectorAll('.cart-fbt__item').length > 0;
  }

  function preserveManualTemplate(el) {
    var tpl = el.querySelector('template[data-fbt-manual-fallback]');
    return tpl ? tpl.outerHTML : '';
  }

  function mountFbtBlock(el, blockHtml, templateHtml) {
    el.innerHTML = blockHtml + (templateHtml || '');
    var root = el.querySelector('[data-fbt-root]');
    if (root) initCartFbt(root);
    return root;
  }

  function loadMinicartFbt(el, force) {
    if (!el || !el.dataset.url) return Promise.resolve();

    var existingRoot = el.querySelector('[data-fbt-root]');
    if (!force && existingRoot) {
      initCartFbt(existingRoot);
      return Promise.resolve();
    }

    if (force && existingRoot && fbtHasItems(existingRoot)) {
      initCartFbt(existingRoot);
      return Promise.resolve();
    }

    var templateHtml = preserveManualTemplate(el);
    var manualHtml = '';
    if (templateHtml) {
      var tmp = document.createElement('div');
      tmp.innerHTML = templateHtml;
      var tpl = tmp.querySelector('template[data-fbt-manual-fallback]');
      manualHtml = tpl ? tpl.innerHTML.trim() : '';
    }

    el.classList.add('cart-fbt-wrap--loading');

    return fetch(el.dataset.url)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var block = html.querySelector('.cart-fbt');

        if (block && fbtHasItems(block)) {
          mountFbtBlock(el, block.outerHTML, templateHtml);
          return;
        }

        if (manualHtml && manualHtml.indexOf('cart-fbt__item') !== -1) {
          mountFbtBlock(el, manualHtml, templateHtml);
          return;
        }

        if (existingRoot && fbtHasItems(existingRoot)) {
          initCartFbt(existingRoot);
          return;
        }

        if (manualHtml) {
          mountFbtBlock(el, manualHtml, templateHtml);
          return;
        }

        el.remove();
      })
      .catch(function (e) {
        console.error('[CartFBT]', e);
        if (manualHtml) {
          mountFbtBlock(el, manualHtml, templateHtml);
          return;
        }
        if (existingRoot && fbtHasItems(existingRoot)) {
          initCartFbt(existingRoot);
          return;
        }
        el.remove();
      })
      .finally(function () {
        el.classList.remove('cart-fbt-wrap--loading');
      });
  }

  function reloadMinicartFbtBlocks() {
    document.querySelectorAll('minicart-fbt').forEach(function (el) {
      var root = el.querySelector('[data-fbt-root]');
      if (root && fbtHasItems(root)) {
        initCartFbt(root);
        return;
      }
      loadMinicartFbt(el, true);
    });
  }

  function initMinicartFbtElements() {
    document.querySelectorAll('minicart-fbt').forEach(function (el) {
      loadMinicartFbt(el, false);
    });
  }

  function initCartFbtVisibilityGuard(){ensureMinicartFbtVisible();var cart=document.getElementById("bls-header_minicart");cart&&cart.dataset.fbtVisibilityGuard!=="true"&&(cart.dataset.fbtVisibilityGuard="true",new MutationObserver(function(){cart.classList.contains("bls__opend-popup-header")&&ensureMinicartFbtVisible()}).observe(cart,{attributes:!0,attributeFilter:["class"]}))}class MinicartFbt extends HTMLElement {
    connectedCallback() {
      loadMinicartFbt(this, false);
    }
  }

  function attachFbtDelegates() {
    if (document.documentElement.dataset.cartFbtDelegates === 'true') return;
    document.documentElement.dataset.cartFbtDelegates = 'true';

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-fbt-toggle]');
      if (!toggle) return;
      var root = toggle.closest('[data-fbt-root]');
      if (!root) return;
      event.preventDefault();
      toggleFbtCollapse(root);
    });

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var roots = node.matches && node.matches('[data-fbt-root]')
            ? [node]
            : Array.prototype.slice.call(node.querySelectorAll ? node.querySelectorAll('[data-fbt-root]') : []);
          roots.forEach(function (root) {
            setFbtCollapsed(root);
            initCartFbt(root);
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (!customElements.get('minicart-fbt')) {
    customElements.define('minicart-fbt', MinicartFbt);
  }

  attachFbtDelegates();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      initMinicartFbtElements();
    });
  } else {
    initAll();
    initMinicartFbtElements();
  }

  document.addEventListener('shopify:section:load', function () {
    initAll();
    initMinicartFbtElements();
  });
})();

/* codex-touch:1781083271195 */
